import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! LAB APIs
//TODO: LAB APIs
//  Get lab type DD
export const getLabTypeDDAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-list-dd`, data,headers);
};
//  Lab Step One Form
export const createLabProfileAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-lab-profile-admin`, data,headers);
};
//  Lab Step Two Form
export const createLabComplianceAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}upsert-lab-detail-admin`, data,headers);
};
//  Lab Step three Form
export const createLabServiceAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}upsert-lab-service-admin`, data,headers);
};
//  Lab Step four Form
export const createLabBankAPI = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}upsert-lab-bank-detail-admin`, data,headers);
};
//  Lab Details
export const getLabDetailsAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-detail`, data,headers);
};
//  Lab Details
export const labApprovalAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}approvel-lab`, data,headers);
};
export const getLabDetailsOneAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-profile-detail-admin`, data,headers);
};
export const getLabDetailsTwo = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-detail-admin`, data,headers);
};
export const getLabDetailsThree = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-service-detail-admin`, data,headers);
};
export const getLabDetailsFour = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}lab-bank-detail-admin`, data,headers);
};
export const getHospitalStepOne = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-profile-detail-admin`, data,headers);
};
export const getHospitalSecondStep = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}hospital-service-detail-admin`, data,headers);
};
export const updateLabEdit = async (data) => {
  const headers = createFormHeaders()   
  return await axios.post(`${BASE_URL}update-lab-edit`, data,headers);
};